import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-student-lesson-main',
  templateUrl: './student-lesson-main.component.html',
  styleUrls: ['./student-lesson-main.component.scss']
})
export class StudentLessonMainComponent implements OnInit {

  lessonID: number;
  error: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.getLessonIDFromUrlParams();
  }

  getLessonIDFromUrlParams(){
    // route.snapshot is static image of route info shortly after component was created
    // parammap is a dictionary of route parameter values from url
    // Javascript + operator converts string to a number
    this.lessonID = +this.route.snapshot.paramMap.get('lessonid');
    this.error = this.route.snapshot.paramMap.get('error');

  }

}
